import React from "react";

const ForceErrorPage: React.FC = () => {
  throw new Error("This is a forced fatal error for testing purposes!");
};

export default ForceErrorPage;
